import axios from 'axios'
import * as ConstantsBase from '../Constants/base'
import { environmentConfig } from '../Utility/Utility'


export  const StoresDropDown = (AuthDataStores,Authstr) => {

     const getUrl = environmentConfig();
     const requestUrl = getUrl+ ConstantsBase.VendorStoresDropDown+AuthDataStores

     try {
      const data =  axios({
        method: 'get',
        url: requestUrl,
        headers: { 'Content-Type': 'application/json;' , Authorization :Authstr },
        validateStatus: function (status) { return status >= 200 }
      })
      return data;
     }
     catch (e) {
      return e;
    }
}